/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "CustomerManagement": {
                                "fields": {
                                  "enableInstantProfiles": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "collectBeforeCheckout": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "collectAfterCheckout": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "useCardOnFile": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagementUseCardOnFileSettings",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "showAddCustomerCartRow": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "showEmailCollectionScreen": {
                                    "type": "bool",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                }
                              },
                              "CustomerManagementUseCardOnFileSettings": {
                                "fields": {
                                  "showSaveCardAfterCheckout": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "cardOnFileEnabled": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.CustomerManagement && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.CustomerManagementUseCardOnFileSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE CustomerManagement @ squareup/devicesettings/profiles/v2/model/settings/common/customer_management.proto at 17:1
 */
export const CustomerManagement = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagement');
fixType(CustomerManagement);
Builder.createAndAttachToType(CustomerManagement);
/**
 * SOURCE CustomerManagementUseCardOnFileSettings @ squareup/devicesettings/profiles/v2/model/settings/common/customer_management.proto at 26:1
 */
export const CustomerManagementUseCardOnFileSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagementUseCardOnFileSettings');
fixType(CustomerManagementUseCardOnFileSettings);
Builder.createAndAttachToType(CustomerManagementUseCardOnFileSettings);